import SelectedApplicant from 'components/applicant/SelectedApplicant';
import DataTable from 'components/datatable';
import ErrorBoundary from 'components/ErrorBoundary';
import NotFound404 from 'components/NotFound404';
import Spinner from 'components/Spinner';
import Error from 'components/Error';
import WizardActions from 'components/WizardActions';
import Search from 'containers/search';
import { LESSON_STATUS } from 'containers/search/SearchType';
import {
  markTheoryLessonEntryDone,
  searchApplicantsAction,
  updateSearchTermsAction,
  resetApplicantsAction
} from 'ducks/applicantsLessonStatus';
import { showModal } from 'ducks/modal';
import { resetWorkItem } from 'ducks/workItem';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Container } from 'rebass';
import { bindActionCreators } from 'redux';
import hasRole from 'util/hasRole';
import { getCourseDriverCardDownloadUrl } from 'service/api';


class Status extends React.Component {

  markTheoryDone = (entry) => {
    this.props.markTheoryLessonEntryDone({entry, applicants: this.props.applicants});
  };

  showSaveModal = (selectedApplicant, selectedLesson) => {

    if (~selectedLesson.lesson.lessonType.indexOf('THEORY') || ~selectedLesson.lesson.lessonType.indexOf('TRAINING')) {
      const applicantNameAndTrafiId = `${selectedApplicant.lastName}, ${selectedApplicant.firstNames} (${selectedApplicant.trafiId})`;
      const modalProps = {
        applicantNameAndTrafiId,
        lessonEntry: selectedLesson,
        saveFn: this.markTheoryDone,
        examClasses: [selectedLesson.lesson.examClass],
        lessons: [selectedLesson.lesson],
        applicantId: selectedApplicant.entityId,
        error: this.props.entryError
      };
      this.props.showCompleteUndoneEntryModal(modalProps);
    } else {
      // TODO: Show driving lesson edit screen/modal or what not
    }
  };

  showSelectModal = (selectedApplicant) => {
    this.props.showSelectUndoneEntryModal({applicant: selectedApplicant})
  };

  showModal = () => {
    const selectedApplicant = this.props.applicants.find(a => a.selected);

    if (selectedApplicant.lessons.length === 1) {
      const selectedLesson = selectedApplicant.lessons[0];
      this.showSaveModal(selectedApplicant, selectedLesson);
    }
    else  {
      this.showSelectModal(selectedApplicant);
    }
  };

  selectedApplicantPreviousFn = () => {
    this.searchApplicantLessons(this.props.searchTerms);
    this.props.resetWorkItem();
  };

  searchApplicantLessons = (searchTerms) => {
    this.props.searchApplicantLessons(searchTerms);
  };

  componentWillUnmount() {
    this.props.resetApplicants();
  };

  canOpenCourseDriverCardPdf = () => {
    const { applicants, selectedApplicant, searchTerms } = this.props
    return applicants && applicants.length > 0 && !selectedApplicant.applicant && !searchTerms.applicantName
      && searchTerms.courseNumber && searchTerms.courseUnit && searchTerms.courseYear

  }

  openCourseDriverCardPdf = () => {
    window.open(getCourseDriverCardDownloadUrl(this.props.currentCourse), '_blank');
  };

  render() {

    const {
      applicants,
      loggedUser,
      saving,
      selectedApplicant,
      tableType,
      workItemError,
      workItemLoading,
      updateSearchTerms,
      searchTerms,
      loading,
      error,
      showProRequirements,
    } = this.props;
    
    const isAllowed = hasRole(loggedUser, ['KULTU_SEURANTA_ADMIN', 'KULTU_SEURANTA_KIRJAAJA', 'KULTU_SEURANTA_KATSELIJA']);

    if (isAllowed) {
      return (
        <Container
          textAlign='center'
          pb={7}>
          <ErrorBoundary>
            {saving && <Spinner />}
            {!selectedApplicant.applicant &&
            <Search
              searchType={LESSON_STATUS}
              searchFn={(searchTerms) => this.searchApplicantLessons(searchTerms)}
              updateSearchTerms={updateSearchTerms}
              searchTerms={searchTerms}
            />}
            {loading.applicants && !error && <Spinner />}
            {error && !loading.applicants && <Error message={error.message} />}
            {!!applicants && applicants.length > 0 && !selectedApplicant.applicant && !loading.applicants &&
            <DataTable
              tableType={tableType}
              rows={applicants}
              rowKey='entityId'
              showProColumns={showProRequirements}
            />
            }
            {!!selectedApplicant.applicant &&
            !loading.applicants &&
            <SelectedApplicant
              {...selectedApplicant}
              error={workItemError}
              loading={workItemLoading}
              previousFn={this.selectedApplicantPreviousFn} />
            }
            {tableType === 'UNDONE_STATUS' && !selectedApplicant.applicant && hasRole(loggedUser, ['KULTU_SEURANTA_ADMIN', 'KULTU_SEURANTA_KIRJAAJA']) &&
            <WizardActions
              nextText='action.mark_lesson'
              nextFn={this.showModal}
              nextDisabled={!applicants || applicants.filter(a => a.selected).length === 0}
              loading={false} />
            }
            {tableType === 'THEORY_STATUS' && this.canOpenCourseDriverCardPdf() && hasRole(loggedUser, ['KULTU_ADMIN'/*TODO: Feature toggle for admins only, 'KULTU_SEURANTA_ADMIN', 'KULTU_SEURANTA_KIRJAAJA'*/]) &&
            <WizardActions
              nextText='action.print_drivercard_pdf_course'
              nextFn={this.openCourseDriverCardPdf}
              loading={false} />
            }
          </ErrorBoundary>
        </Container>
      );
    } else {
      return <NotFound404 message={!isAllowed && 'app.missing_perm'} />;
    }
  }
}

Status.propTypes = {
  applicants: PropTypes.array,
  loggedUser: PropTypes.object,
  currentCourse: PropTypes.object,
  entryError: PropTypes.string,
  selectedApplicant: PropTypes.object,
  workItemLoading: PropTypes.bool,
  workItemError: PropTypes.object,
  searchApplicantLessons: PropTypes.func,
  searchTerms: PropTypes.object,
  updateSearchTerms: PropTypes.func,
  saving: PropTypes.bool,
  loading: PropTypes.object,
  error: PropTypes.object,
  showProRequirements: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    tableType: state.applicantLessonStatus.tableType,
    applicants: state.applicantLessonStatus.applicants,
    loggedUser: state.userState.user,
    currentCourse: state.userState.currentCourse,
    entryError: state.applicantLessonStatus.error,
    selectedApplicant: state.workItem.selectedApplicant,
    workItemLoading: state.workItem.loading,
    workItemError: state.workItem.error,
    saving: state.applicantLessonStatus.loading.saving,
    searchTerms: state.applicantLessonStatus.searchTerms,
    loading: state.applicantLessonStatus.loading,
    error: state.applicantLessonStatus.error,
    showProRequirements: state.userState.courseData && state.userState.courseData.proCourse,
    searchTermsChanged: state.applicantLessonStatus.searchTermsChanged
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  searchApplicantLessons: (searchTerms) => searchApplicantsAction(searchTerms),
  resetWorkItem: () => resetWorkItem(),
  showCompleteUndoneEntryModal: (modalProps) => showModal('COMPLETE_UNDONE_ENTRY', modalProps),
  showSelectUndoneEntryModal: (modalProps) => showModal('SELECT_UNDONE_ENTRY', modalProps),
  markTheoryLessonEntryDone: (data) => markTheoryLessonEntryDone(data),
  updateSearchTerms: (searchTerms) => updateSearchTermsAction(searchTerms),
  resetApplicants: () => resetApplicantsAction(),
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Status);


// WEBPACK FOOTER //
// ./src/containers/status/index.js